//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import textInput from "../components/textInput.vue";

export default {
  components: {
    textInput,
  },
  props: {
    title: {
      default: "Input Modal",
    },
    isVisible: {
      default: false,
    },
    inputFields: {
      default: false,
    },
  },
};
